import { BoxxGenericState, getGenericInitialState } from "@boxx/core";
import {
  IStoreProfileStateError,
  IStoreProfileStateSuccess,
  StoreProfileStateType,
} from "@boxx/store-core";
import { ActionReducer, createReducer, on } from "@ngrx/store";
import { StoreProfileModel } from "../../models/Store.model";
import * as fromConfigurationActions from "./store-configuration.actions";

export interface IStoreProfileState
  extends BoxxGenericState<
    StoreProfileModel,
    IStoreProfileStateSuccess,
    IStoreProfileStateError
  > {
  selectedProfile: StoreProfileModel;
}

export const ConfigurationInitialState: IStoreProfileState = {
  ...getGenericInitialState(),
  data: null,
  selectedProfile: null,
};

export const storeConfigurationReducer: ActionReducer<IStoreProfileState> =
  createReducer(
    ConfigurationInitialState,
    on(
      fromConfigurationActions.loadProfileBeginAction,
      (state): IStoreProfileState => ({
        ...state,
        isLoading: true,
        error: null,
        success: null,
      })
    ),
    on(
      fromConfigurationActions.updateProfileBeginAction,
      fromConfigurationActions.uploadImageProfileBeginAction,
      fromConfigurationActions.deleteImageProfileBeginAction,
      (state): IStoreProfileState => ({
        ...state,
        isLoading: false,
        error: null,
        success: null,
      })
    ),
    on(
      fromConfigurationActions.loadProfileSuccessAction,
      (state, action): IStoreProfileState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: {
          after: getStoreProfileActionType(action.type),
          data: action.payload,
        },
      })
    ),
    on(
      fromConfigurationActions.loadProfileSuccessAction,
      fromConfigurationActions.deleteImageProfileSuccessAction,
      (state, action): IStoreProfileState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: {
          after: getStoreProfileActionType(action.type),
          data: action.payload,
        },
      })
    ),
    on(
      fromConfigurationActions.loadProfileFailAction,
      fromConfigurationActions.updateProfileFailAction,
      fromConfigurationActions.uploadImageProfileFailAction,
      fromConfigurationActions.deleteImageProfileFailAction,
      (state, action): IStoreProfileState => ({
        ...state,
        isLoading: false,
        error: {
          after: getStoreProfileActionType(action.type),
          error: action.errors,
        },
      })
    ),
    on(
      fromConfigurationActions.uploadImageProfileSuccessAction,
      (state, action): IStoreProfileState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: {
          after: getStoreProfileActionType(action.type),
          data: action.payload,
        },
      })
    ),
    //eslint-disable-next-line @typescript-eslint/naming-convention
    on(fromConfigurationActions.updateProfileSuccessAction, (state, action) =>
      Object.assign({}, state, {
        isLoading: false,
        fetched: true,
        error: null,
        success: {
          after: getStoreProfileActionType(action.type),
          data: action.payload,
        },
        data: state.data,
      })
    ),

      on(fromConfigurationActions.clearProfileSuccessErrorDataAction, (state) => ({
        ...state,
        loaded: {
          success: null,
          after: '',
          data: ''
        },
        success: {
          after: ''
        }
      })),
   
  );

const getStoreProfileActionType = (
  type: fromConfigurationActions.StoreProfileActionTypes
) => {
  let action: StoreProfileStateType;

  switch (type) {
    case fromConfigurationActions.StoreProfileActionTypes.loadProfileSuccess:
    case fromConfigurationActions.StoreProfileActionTypes.loadProfileFail:
      action = "LOAD_PROFILE";
      break;
    case fromConfigurationActions.StoreProfileActionTypes.updateProfileSuccess:
    case fromConfigurationActions.StoreProfileActionTypes.updateProfileFail:
      action = "UPDATE_PROFILE";
      break;
    case fromConfigurationActions.StoreProfileActionTypes.imageProfileUploadedSuccess:
    case fromConfigurationActions.StoreProfileActionTypes.imageProfileUploadedFail:
      action = "UPDATE_PROFILE_IMAGE";
      break;
    case fromConfigurationActions.StoreProfileActionTypes.deleteImageProfileSuccess:
    case fromConfigurationActions.StoreProfileActionTypes.deleteImageProfileFail:
      action = "DELETE_PROFILE_IMAGE";
      break;
    default:
      action = "UNKNOWN";
  }

  return action;
};
